import {
  BrandIcon,
  DropDownFlag,
  DropdownMenu,
  DropdownSelectList,
  ListItem,
  Navbar,
  SIZES,
  useResponsive,
  VARIANTS,
} from '@aptuno/aptuno-ui';
import { TraceableProcess } from '../../../services/analytics/model';
import { isLoggedIn } from '@shared/Authentication';
import { getLocalStorageItem } from '@shared/utils';
import { isColombia, RenderOnlyInCountries } from '@shared/utils/region-utils';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { loginItem, mainlinkOptions, menuItems, RightSide, useOptionsNavbar } from './NavbarData';
import { CompleteEstateApplicationButton } from '@contexts/Estate';
import { constants } from '@contexts/Estate/Shared/commons';
import { useAnalyticsTracker } from '@services/analytics';

const NavbarAptuno = () => {
  const { isMobile } = useResponsive();
  const [user, setUser] = useState<any>();
  const isLoggedInUser = user ? isLoggedIn(user) : false;
  const data = getLocalStorageItem('user-data');
  const tracker = useAnalyticsTracker();
  const { isSmallDesktop } = useResponsive();

  useEffect(() => {
    setUser(data && JSON.parse(data));
  }, [data]);

  const checkUserName = () => {
    if (user?.data) {
      const nameUserLogged = user?.data?.firstName;
      if (nameUserLogged === '') {
        return 'Bienvenido';
      } else {
        return nameUserLogged;
      }
    }
    return isMobile ? 'Ingresar' : 'Ingresa a tu cuenta';
  };

  const NavbarSegmentEvents = (labelNavbar) => {
    tracker.trackEvent({
      action: 'NavBar Clicked',
      category: TraceableProcess.NAVIGATION,
      label: labelNavbar,
      labelNavbar: labelNavbar,
    });
  };

  const OptionsNavbar = useOptionsNavbar();

  const buildLinks = (isSmallDesktop: boolean) => {
    const recommendationsLinkStyle = {
      background: 'linear-gradient(180deg, #F0323C 0%, #FF784B 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    };

    const defaultNavbarItems = OptionsNavbar.map((link) => (
      <Link key={link.key} href={link.href} target={link.target} rel={link.rel}>
        <a style={link.key === 'recomendaciones_para_ti' ? recommendationsLinkStyle : undefined}>
          <span onClick={() => NavbarSegmentEvents(link.text)}>{link.text}</span>
        </a>
      </Link>
    ));

    if (isSmallDesktop) {
      return [
        ...defaultNavbarItems.slice(0, -3),
        <DropdownSelectList
          key={'DropdownSelectListNavbar'}
          openOnHover={true}
          onlyLowerCase={false}
          variant={VARIANTS.SECONDARY_LIGHT}
          onSelect={(item) => {
            NavbarSegmentEvents(item.name);
            window.location.href = item.id;
          }}
          selectedItem={{ id: 'default', name: 'Más opciones' }}
          items={OptionsNavbar.slice(-3).map((link) => {
            return {
              id: link.href,
              name: link.text,
            } as ListItem;
          })}
        />,
      ];
    }
    return defaultNavbarItems;
  };

  return (
    <div>
      <Navbar
        brand={<BrandIcon />}
        links={buildLinks(isSmallDesktop)}
        mainlinks={mainlinkOptions.map((link) => (
          <Link key={link.key} href={link.href}>
            <a>
              <span onClick={() => NavbarSegmentEvents(link.text)}>{link.text}</span>
            </a>
          </Link>
        ))}
        actions={
          <RightSide isMobile={isMobile}>
            <RenderOnlyInCountries countries={constants.ESTATE_APPLICATION_ACTIONS_COUNTRIES}>
              <CompleteEstateApplicationButton />
            </RenderOnlyInCountries>
            <DropDownFlag defaultCountryCode={isColombia() ? 'CO' : 'MX'} />
            <DropdownMenu
              title={checkUserName()}
              right
              fitWidth
              fitHeight
              openOnHover
              items={menuItems}
              size={SIZES.SMALL}
              variant={VARIANTS.WARNING_LIGHT}
              authenticated={isLoggedInUser}
              loginItem={loginItem}
            />
          </RightSide>
        }
      />
    </div>
  );
};

export default NavbarAptuno;
